import { router } from "../../router";
import { DrawerOptions, useDrawerStore } from "../../store/drawers";

// Override titles by adding this to options where initiated
// props: { modalTitleOverride: "openModal props 321" },
export const openModal = (url: string, options?: DrawerOptions) => {
  return useDrawerStore().open("modal", url, options);
};
export const openSlideover = (url: string, options?: DrawerOptions) => {
  return useDrawerStore().open("slideover", url, options);
};
export async function openPage(url: string) {
  return await router.push(url);
}
